import { useEffect } from 'react';
import Spinner from '../../../components/common/Spinner';
import useSignupStore, { MAX_INTERESTS } from '../../../store/useSignupStore';
import { showToast } from '../../../store/useToastStore';

export default function InterestsStep() {
  const { activityCategories, activitiesLoading, activities } = useSignupStore();
  const loadActivities = useSignupStore((s) => s.loadActivities);
  const toggleActivity = useSignupStore((s) => s.toggleActivity);
  const goNext = useSignupStore((s) => s.goNext);

  useEffect(() => {
    loadActivities().catch((err) => showToast(err.message));
  }, [loadActivities]);

  const atLimit = activities.length >= MAX_INTERESTS;

  return (
    <>
      <div className="ob-eyebrow">Interest</div>
      <h1>Select activities</h1>
      <p className="sub">
        This helps you find <b>parents with similar interests</b>, swap recommendations, and get to know each other
        beyond drop-off.
      </p>

      <div className="ob-counter">{activities.length}/{MAX_INTERESTS}</div>

      <div className="ob-scroll">
        {activitiesLoading && !activityCategories.length ? (
          <div className="ob-loading"><Spinner variant="green" /> Loading activities…</div>
        ) : (
          activityCategories.map((cat) => (
            <div className="ob-cat" key={cat.id}>
              <div className="ob-cat-label">{cat.label}</div>
              <div className="ob-chip-row">
                {cat.items.map((item) => {
                  const on = activities.includes(item.id);
                  return (
                    <button
                      key={item.id}
                      type="button"
                      className={`ob-chip ${on ? 'on' : ''}`}
                      /* the cap is a selection limit, not a reason to hide the
                         rest — already-picked chips stay tappable to unpick */
                      disabled={!on && atLimit}
                      onClick={() => toggleActivity(item.id)}
                    >
                      <span className="em">{item.emoji}</span>{item.label}
                    </button>
                  );
                })}
              </div>
            </div>
          ))
        )}
      </div>

      {/* at least one activity is required (Mohit, 30 Sep) */}
      <button className="btn btn-primary btn-primary-full ob-cta" disabled={!activities.length} onClick={goNext}>
        {activities.length ? 'Continue' : 'Pick at least one activity'}
      </button>
    </>
  );
}
